import { ChangeEvent } from "react"

import { useLazyGetCitiesQuery, useLazyGetStatesQuery } from "store/api/dictionaryApi"
import { UITypes } from "types"

import { InputNew } from "components/form/InputNew"
import { InputNumber } from "components/form/InputNumber"
import { InputPhone } from "components/form/InputPhone"
import { SelectDynamic } from "components/form/SelectDynamic"

import { FieldsRow, SelectsRow, StepperLabel } from "./shared"

export interface ReferralFormValues {
  homeowner_name: string
  phone: string
  email: string
  thermostat_quantity: number
  address1: string
  city: UITypes.Option[]
  state: UITypes.Option[]
}

interface Props {
  values: ReferralFormValues
  error: { field: string; message: string }
  setValues: React.Dispatch<React.SetStateAction<ReferralFormValues>>
}

export const ReferralFormFields = ({ values, error, setValues }: Props) => {
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget
    setValues(prevState => ({ ...prevState, [name]: value }))
  }

  return (
    <>
      <InputNew
        label="Property address"
        placeholder="Street address"
        name="address1"
        value={values.address1}
        onChange={onInputChange}
        errorMessage={error.field === "address1" ? error.message : ""}
      />
      <SelectsRow>
        <SelectDynamic
          label="State"
          placeholder="Select state"
          name="state"
          valueName="id"
          labelName="name"
          values={values.state}
          useLazyQuery={useLazyGetStatesQuery}
          queryParams={{ country_id: 1 }}
          onChange={state => setValues(prevState => ({ ...prevState, state, city: [] }))}
          errorMessage={error.field === "state" ? error.message : ""}
        />
        <SelectDynamic
          label="City"
          placeholder="Select city"
          name="city"
          valueName="id"
          labelName="name"
          values={values.city}
          useLazyQuery={useLazyGetCitiesQuery}
          queryParams={{
            state_id: values.state[0]?.value != null ? `${values.state[0].value}` : undefined,
          }}
          onChange={city => setValues(prevState => ({ ...prevState, city }))}
          errorMessage={error.field === "city" ? error.message : ""}
        />
      </SelectsRow>
      <InputNew
        label="Customer name"
        placeholder="Enter"
        name="homeowner_name"
        value={values.homeowner_name}
        onChange={onInputChange}
        errorMessage={error.field === "homeowner_name" ? error.message : ""}
      />
      <FieldsRow>
        <InputNew
          label="Customer email (Optional)"
          placeholder="Enter"
          name="email"
          value={values.email}
          onChange={onInputChange}
          errorMessage={error.field === "email" ? error.message : ""}
        />
        <InputPhone
          label="Customer phone"
          placeholder="Enter"
          name="phone"
          value={values.phone}
          onChange={value => setValues(prevState => ({ ...prevState, phone: value }))}
          errorMessage={error.field === "phone" ? error.message : ""}
        />
      </FieldsRow>
      <StepperLabel>Thermostats for this property</StepperLabel>
      <InputNumber
        value={values.thermostat_quantity}
        minValue={1}
        dataTestId="thermostat-quantity"
        onInputChange={thermostat_quantity => setValues(prevState => ({ ...prevState, thermostat_quantity }))}
      />
    </>
  )
}
